module.exports = __webpack_public_path__ + "static/icon0026c9725091816a7330e29f77f6767ceb5.png";